// import { Component, EventEmitter, Output } from '@angular/core';

// @Component({
//   selector: 'digi-upload',
//   templateUrl: './input-upload-file.component.html',
//   styleUrl: './input-upload-file.component.scss',
// })
// export class InputUploadFileComponent {
//   // Output để phát tệp đã chọn
//   @Output() fileSelected = new EventEmitter<File>();

//   // Tên tệp đã chọn
//   fileName: string = '';

//   // Hàm xử lý khi chọn tệp
//   onFileSelected(event: Event): void {
//     const input = event.target as HTMLInputElement;
//     if (input.files && input.files.length > 0) {
//       const file = input.files[0];
//       this.fileName = file.name;
//       this.fileSelected.emit(file);
//     }
//   }
// }

import { Component, EventEmitter, Output, Input } from '@angular/core';

@Component({
  selector: 'digi-upload',
  templateUrl: './input-upload-file.component.html',
  styleUrl: './input-upload-file.component.scss',
})
export class InputUploadFileComponent {
  // Output để phát tệp đã chọn
  @Output() fileSelected = new EventEmitter<File>();

  @Input() fileName: string = '';
  @Input() fileUrl: string = '';
  private internalFileName: string = '';

  get displayFileName(): string {
    return this.fileName || this.internalFileName;
  }

  // Hàm xử lý khi chọn tệp
  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      this.internalFileName = file.name;
      this.fileSelected.emit(file);
    }
  }

  // Hàm tải file về máy khi có url
  downloadFile(): void {
    if (this.fileUrl) {
      const link = document.createElement('a');
      link.href = this.fileUrl;
      link.download = this.displayFileName;
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }

  // Hàm xóa file đã upload
  removeFile(): void {
    this.internalFileName = '';
    this.fileName = '';
    this.fileUrl = '';
    this.fileSelected.emit(undefined);
  }
}